import { QuestionsImportSource } from "@repo/app-types/entities/question";
import {
  PermissionActions,
  PermissionSubjects,
} from "@repo/app-types/entities/teammatePermissions";
import { Textarea } from "@repo/ui/Inputs/textarea";
import { type FC, type ReactNode, useState } from "react";
import { Can } from "../../../helpers/teammateAuthorizationContext.js";
import { questionsImportTypeToPlaceholder } from "../surveyQuestions/importQuestionsModal.js";

export const MIN_JD_LENGTH = 20;
export const MAX_JD_LENGTH = 15000;

interface JobDescriptionTextAreaProps {
  labelAccessory?: ReactNode;
  value: string;
  onChange: (newValue: string) => void;
  description: string;
  errorText?: string;
  height?: string;
}

export const JobDescriptionTextArea: FC<JobDescriptionTextAreaProps> = ({
  labelAccessory,
  value,
  onChange,
  errorText,
  description,
  height = "250px",
}) => {
  const [error, setError] = useState("");

  return (
    <Can
      I={PermissionActions.UPDATE}
      a={PermissionSubjects.JOB_OPENINGS}
      passThrough={true}
    >
      {(allowed) => (
        <Textarea
          label="Job description"
          labelAccessory={labelAccessory}
          value={value}
          onChange={(newValue) => {
            setError(""); // Clear error on change
            onChange(newValue);
          }}
          onBlur={(evt) => {
            const newValue = evt.target.value;
            if (newValue.length > 0 && newValue.length < MIN_JD_LENGTH) {
              setError(
                `Job description must be at least ${MIN_JD_LENGTH.toString()} characters long`,
              );
            } else if (newValue.length > MAX_JD_LENGTH) {
              setError(
                `Job description must be less than ${MAX_JD_LENGTH.toString()} characters long`,
              );
            } else {
              setError("");
            }
          }}
          maxLength={MAX_JD_LENGTH}
          placeholder={
            questionsImportTypeToPlaceholder[
              QuestionsImportSource.JOB_DESCRIPTION
            ]
          }
          errorDescription={error || errorText}
          description={description}
          className="w-full"
          height={height}
          isDisabled={!allowed}
        />
      )}
    </Can>
  );
};
